<script setup lang="ts">
import AppLayout from '@/Layouts/AppLayout.vue';
import DeleteUserForm from '@/Pages/Profile/Partials/DeleteUserForm.vue';
import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue';
import SectionBorder from '@/Components/SectionBorder.vue';
import TwoFactorAuthenticationForm from '@/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue';
import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue';
import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue';
import { usePage } from '@inertiajs/vue3';
import { SharedPageProps } from '@/Types/inertia';
import { useAuth } from '@/Composables/Auth';
import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
// defineProps({
//     confirmsTwoFactorAuthentication: Boolean,
//     sessions: Array,
// });
containerGapForForm();
const page = usePage<SharedPageProps>();
const { isSuperadmin, isAdmin } = useAuth();
pageTitle.value = "Profile";

</script>

<template>
    <!-- <AppLayout title="Profile"> -->
        <div>

            <div v-if="page.props?.jetstream?.canUpdateProfileInformation">
                <UpdateProfileInformationForm :user="page.props?.auth?.user" />

                <div class="py-10">
                    <divider></divider>
                </div>
            </div>

            <div v-if="page.props?.jetstream?.canUpdatePassword">
                <UpdatePasswordForm class="" />
                <div class="py-10">
                    <v-divider></v-divider>
                </div>
            </div>

            <div v-if="page.props?.jetstream?.canManageTwoFactorAuthentication">
                <TwoFactorAuthenticationForm
                    :requires-confirmation="page.props.confirmsTwoFactorAuthentication"
                    class=""
                />
                <div class="py-10">
                    <!-- <v-divider></v-divider> -->
                </div>
            </div>
            <!-- 
            <LogoutOtherBrowserSessionsForm :sessions="sessions" class="mt-10 sm:mt-0" />

            <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                <SectionBorder />

                <DeleteUserForm class="mt-10 sm:mt-0" />
            </template> -->
        </div>
    <!-- </AppLayout> -->
</template>
